export default { 
  name : 'product.event.id',
  objectType : 'product.event',
  valueType : 'string',
  displayName : 'Event ID',
  get : ( obj, cxt ) => {
    return obj?.data?.eventId
  }
}
